import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'shared-assets/lib/colors';
import SVG from 'react-inlinesvg';

const TagContainer = styled.span`
  font-size: 0.7em;
  font-weight: 600;
  background: ${props =>
    props.type === 'default'
      ? colors.fill.default
      : colors[props.type === 'subtle' ? 'light' : props.type]};
  color: ${props => (props.type === 'warning' ? colors.warningText : '#fff')};
  border-radius: 3px;
  padding: 3px 5px;
  margin: 0 3px;

  a.closeButton {
    color: #fff;
  }

  button.closeButton {
    align-items: center;
    height: 100%;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;

    &:focus {
      outline: 0;
    }

    span {
      display: flex;
    }
  }

  svg {
    fill: #fff;
    height: 9px;
  }
`;

export const TYPES = {
  subtle: 'subtle',
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  default: 'default',
};

const Tag = ({ type, children, showCloseButton, onClose, ...rest }) => (
  <TagContainer type={type} {...rest}>
    {children}
    <If condition={showCloseButton}>
      <a className="closeButton" onClick={onClose}>
        <SVG cacheGetRequests src={require('../../assets/icons/close.svg')} />
      </a>
    </If>
  </TagContainer>
);

Tag.propTypes = {
  type: PropTypes.oneOf(Object.values(TYPES)),
  children: PropTypes.node,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
};

Tag.defaultProps = {
  type: TYPES.subtle,
  children: undefined,
  showCloseButton: false,
  onClose: () => {},
};

export default Tag;
